/*global VeloxWebView*/

module.exports = [
    {
        type: "startup", //called on startup
        interceptor: function (app, callback){
            var currentLang = VeloxWebView.i18n.getLang() ;
            var savedLang = localStorage.getItem("lang") ;
            if(currentLang !== savedLang){
                VeloxWebView.i18n.setLang(savedLang) ;
            }
            callback() ;
        }
    }
];